// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as OrderFareDashboard from "./components/OrderFareDashboard.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as OrderFareDashboardStateMachine from "../../../app/order/OrderFareDashboardStateMachine.bs.js";
import * as OrderFareDashboardAssetsManager from "../../assets/OrderFareDashboardAssetsManager.bs.js";

OrderFareDashboardAssetsManager.importCss(undefined);

function OrderFareDashboardContainer(Props) {
  var order_crn = Props.order_crn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          return OrderFareDashboardStateMachine.reducer(action, state);
        }), /* LoadingData */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          OrderFareDashboardStateMachine.fetchBaseData(order_crn, dispatch, country);
          
        }), []);
  if (typeof state === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  } else if (state.TAG === /* Dashboard */0) {
    return React.createElement(OrderFareDashboard.make, {
                order_crn: order_crn,
                order_fare: state.order_fare,
                order_details: state.order_details
              });
  } else {
    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: state._0
              });
  }
}

var make = OrderFareDashboardContainer;

export {
  make ,
  
}
/*  Not a pure module */
